import { render, staticRenderFns } from "./biura-glowna.vue?vue&type=template&id=17b32e59&"
import script from "./biura-glowna.vue?vue&type=script&lang=ts&"
export * from "./biura-glowna.vue?vue&type=script&lang=ts&"
import style0 from "./biura-glowna.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BiuraBreadcrumbs: require('/app/components/biura/components/biura-breadcrumbs.vue').default,Map: require('/app/components/map/map.vue').default,BiuraLista: require('/app/components/biura/components/biura-lista.vue').default})
